module.exports = __webpack_public_path__ + "static/media/global-nav-old.822725bd.gif";